import React, { useState, useEffect } from 'react';
import { Modal, Button, Typography, Col } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { isMobile } from '../../../api/Util';

const EditorModal = ({ editorModalData, clearFields, handleCancel, handleSubmit, type }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (editorModalData.modalContent) {
      const contentBlock = htmlToDraft(editorModalData.modalContent);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
      }
    } else {
      setEditorState(EditorState.createEmpty());
    }
  }, [editorModalData.modalContent]);

  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);
    if (editorModalData.onEditorStateChange) {
      editorModalData.onEditorStateChange(newEditorState);
    }
  };
  return (
    <Modal title={editorModalData.title}
      open={editorModalData.isModalOpen}
      onCancel={handleCancel}
      afterClose={() => clearFields()}
      className={`${!isMobile ? 'web-view-modal-data' : 'mobile-view-modal-data'}`}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          onClick={() => {
            if (handleSubmit) {
              handleSubmit(editorState);
            }
          }}
        >
          Submit
        </Button>
      ]}>
   <Col span={24} className="editor-modal-content">
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        toolbar={{
          options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image'],
          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
        }}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
      />
    </Col>
    </Modal>
  )
}

export default EditorModal;
